var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotStreakIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 12.0874C16.25 15.8996 13.0932 18.9657 9.28131 18.7381C5.3634 18.5042 2.68075 14.7363 3.18609 10.7978C3.49178 8.40181 4.61475 6.34719 5.83755 4.75406C6.04967 4.4759 6.268 6.71387 6.48637 6.46731C6.70475 6.21442 8.73231 2.70577 9.43731 1.47299C9.56831 1.24541 9.86775 1.17587 10.0799 1.34024C11.4961 2.40864 16.25 6.42306 16.25 12.0874Z",
    fill: "#FF3B30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6966 11.724L13.3485 9.0721C13.9303 8.5071 13.0297 7.60648 12.4647 8.18835L9.81284 10.8402L7.16097 8.18835C6.59597 7.60648 5.69535 8.5071 6.27722 9.0721L8.9291 11.724L6.27722 14.3759C5.69597 14.9409 6.59597 15.8421 7.16097 15.2596L9.81284 12.6077L12.4647 15.2596C13.0297 15.8421 13.9303 14.9409 13.3485 14.3759L10.6966 11.724Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotStreakIcon);
export default __webpack_public_path__ + "static/media/Not_streak_icon.07678022806143c17516786f01083f45.svg";
export { ForwardRef as ReactComponent };